import { render, staticRenderFns } from "./Koriklar.vue?vue&type=template&id=7a4d32e4&scoped=true"
import script from "./Koriklar.vue?vue&type=script&lang=js"
export * from "./Koriklar.vue?vue&type=script&lang=js"
import style0 from "./Koriklar.vue?vue&type=style&index=0&id=7a4d32e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d32e4",
  null
  
)

export default component.exports